import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed right-4 md:right-6 bottom-6 z-40 w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xl shadow-none transition-all cursor-pointer hover:bg-primary-600 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <i className="ri-arrow-up-line" />
    </button>
  );
}